import React from 'react';
import { string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';

const STUDIOS_BASE_KEY = 'reviews.studios';
const STUDIOS_URL_PREFIX = '/studios';

import './styles.scss';

const StudioSummary = ({ studioName, studioSlug }) => (
    <span className="studio-summary">
        <span className="separator"> | </span>
        <I18n k={`${STUDIOS_BASE_KEY}.given_to`} />
        {/* eslint-disable-next-line */}
        <a href={`${STUDIOS_URL_PREFIX}/${studioSlug || studioName}`} target="_blank">
            {studioName}
        </a>
        <I18n k={`${STUDIOS_BASE_KEY}.title`} />
    </span>
);

StudioSummary.propTypes = {
    studioName: string,
    studioSlug: string,
};

export default StudioSummary;
